// extracted by mini-css-extract-plugin
module.exports = {"root":"root-2ro0Y","name":"name-1H49V"};